import { base64UrlEncode } from './base64UrlEncode';

/**
 * Returns a base64url-encoded JSON state marker encoding the MSAL version
 * so the redirect bridge page (oauthRedirect.html) can parse it and choose the
 * correct redirect handling strategy (BroadcastChannel for v5+ vs
 * hash-monitoring for v4).
 *
 * @param msalVersion - The MSAL package version string (e.g., '4.28.2' or '5.0.0')
 */
export function getMsalV5BridgeState(msalVersion: string): string {
    return base64UrlEncode(JSON.stringify({ msalVersion }));
}
